import * as React from "react";
import {applyMiddleware, createStore} from 'redux'
import {Provider} from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import {routerMiddleware} from 'react-router-redux'
import rootReducer from '../store/reducer/root/reducer';
import logger from 'redux-logger';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from "redux-thunk";
import {api} from "../api/api";
import {checkUserData} from "../store/action/user/user";
import MainRouter from "./MainRouter";
import bugsnag, {Bugsnag} from "@bugsnag/js"
import Settings, {Environment} from "../model/settings/Settings";
import {none, option, Option} from "ts-option";
import {fetchSettings} from "../store/action/settings/settings";
import MapUtils from "../utils/MapUtils";
import * as dynamicMiddlewares from "redux-dynamic-middlewares";
import LoadingAppView from "../components/pages/LoadingAppView";

const mixpanel = require("mixpanel-browser");
const bugsnagReact = require('@bugsnag/plugin-react');

const history = createHistory();
const historyMiddleware = routerMiddleware(history);
const enhancers = [historyMiddleware, thunk, dynamicMiddlewares.default];
export let bugsnagClient: Bugsnag.Client = null;

export const store = createStore(
	rootReducer,
	composeWithDevTools(applyMiddleware(...enhancers))
);

interface State {
	/**
	 * Installer portal settings.
	 */
	settings: Option<Settings>;
}

/**
 * Main router with Redux provider.
 */
export default class ReduxProvider extends React.Component<{}, State> {

	constructor(props: {}) {
		super(props);
		this.state = {
			settings: none
		};
		api.instance.create();
	}

	componentDidMount() {
		store.dispatch(fetchSettings(
			(settings) => {
				if (settings.environment == Environment.Integration || process.env.NODE_ENV != Environment.Production) {
					dynamicMiddlewares.addMiddleware(logger);
				}
				MapUtils.API_KEY = settings.googleMapsApiKey;
				mixpanel.init(settings.mixpanelApiKey);
				this.setState({settings: option(settings)}, () => {
					store.dispatch(checkUserData(() => {}));
				});
			},
			() => {}
		));
	}

	render() {
		return this.state.settings.map(settings => {
			const env = process.env.NODE_ENV == Environment.Production ? settings.environment : Environment.Development;
			bugsnagClient = bugsnag({
				apiKey: settings.bugsnagApiKey,
				releaseStage: env,
				notifyReleaseStages: [
					Environment.Integration,
					Environment.Test,
					Environment.Staging,
					Environment.FB1,
					Environment.FB2,
					Environment.Perf,
					Environment.GdStaging,
					Environment.Production
				],
				maxBreadcrumbs: 12,
				appVersion: require("../../../package.json").version
			});
			bugsnagClient.use(bugsnagReact, React);
			const ErrorBoundary = bugsnagClient.getPlugin('react');
			return (
				<ErrorBoundary>
					<Provider store={store}>
						<MainRouter history={history}/>
					</Provider>
				</ErrorBoundary>
			);
		}).getOrElse(() => <LoadingAppView/>);
	}
}
